import request from '@/utils/request'
import { importLocale } from '@/locale'
import { ApplicationError } from '@/utils/error'
import { getTrackingKey } from '@/utils/api'

import API from './base'

class CheckoutAPI extends API {
  fetchData = ({ checkoutId, isFrame, v2Route }) => {
    if (!checkoutId) {
      return Promise.reject(new ApplicationError('checkout_id is required!'))
    }

    const uri = v2Route ? `${this.uri}/v2` : this.uri

    const path = `${uri}/${checkoutId}?isFrame=${isFrame}`

    return request({
      method: 'GET',
      trackingKey: getTrackingKey(uri),
      path,
    })
  }

  submitData = ({ checkoutId, data = {}, options = {} }) => {
    if (!checkoutId) {
      return Promise.reject(new ApplicationError('checkout_id is required!'))
    }

    const dataToBeSent = { ...data, checkoutId }

    return request(
      {
        method: 'POST',
        trackingKey: getTrackingKey(this.uri, 'CHECKOUT-ID'),
        path: this.uri + `/${checkoutId}`,
        data: this.transformData(dataToBeSent, options),
      },
      { options }
    )
  }

  sendCustomerSatisfactionFeedback = ({
    orderId,
    paymentType,
    score,
    comment,
    options = {},
  }) => {
    const dataToBeSent = {
      orderId,
      paymentType,
      score,
      comment,
    }

    return request(
      {
        method: 'POST',
        trackingKey: getTrackingKey(this.uri, 'customer-satisfaction'),
        path: this.uri + `/customer-satisfaction`,
        data: this.transformData(dataToBeSent, options),
      },
      { options }
    )
  }

  fetchMessages = async (module, locale) => {
    return importLocale(module, locale)
  }

  getResponseCode = (checkoutId, sessionId) => {
    return request(
      {
        method: 'GET',
        trackingKey: getTrackingKey(
          this.uri,
          'CHECKOUT-ID_response-code_SESSION-ID'
        ),
        path: `${this.uri}/${checkoutId}/response-code/${sessionId}`,
      },
      {
        options: {
          attachCkoPublicKey: true,
        },
      }
    )
  }

  paymentOptionsGeneration = (checkoutId, data) => {
    return request({
      method: 'POST',
      path: `${this.uri}/v2/${checkoutId}`,
      data: data ?? {},
      options: { headers: { 'Content-Type': 'application/json' } },
    })
  }

  submitPaymentOptionNova = (checkoutId, data) => {
    return request({
      method: 'POST',
      path: `${this.uri}/v2/${checkoutId}`,
      data: data ?? {},
      options: { headers: { 'Content-Type': 'application/json' } },
    })
  }

  retrieveDocumentUrl = (checkoutId, documentId) => {
    return request({
      method: 'GET',
      path: `${this.uri}/v2/${checkoutId}/loan-documents/${documentId}/review-document`,
    })
  }
}
export default new CheckoutAPI('/checkout')
